import { render, staticRenderFns } from "./VirtualKeyboard.vue?vue&type=template&id=5811d2c3&scoped=true"
import script from "./VirtualKeyboard.vue?vue&type=script&lang=js"
export * from "./VirtualKeyboard.vue?vue&type=script&lang=js"
import style0 from "./VirtualKeyboard.vue?vue&type=style&index=0&id=5811d2c3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811d2c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5811d2c3')) {
      api.createRecord('5811d2c3', component.options)
    } else {
      api.reload('5811d2c3', component.options)
    }
    module.hot.accept("./VirtualKeyboard.vue?vue&type=template&id=5811d2c3&scoped=true", function () {
      api.rerender('5811d2c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/VirtualKeyboard.vue"
export default component.exports